import { useEffect } from "react";
import { useNavigate } from "react-router";

import { USER_ROLE } from "../utils/constants";
import { AuthContext } from "./useAuthentication";
import { use } from "react";

export const useCheckUserRole = () => {
  const navigate = useNavigate();

  const { auth } = use(AuthContext);

  useEffect(() => {
    if (auth.userRole !== USER_ROLE.CS_USER) {
      navigate("/", { replace: true });
    }
  }, [auth, navigate]);
};
